import { render, staticRenderFns } from "./SystemService.vue?vue&type=template&id=2ed8d237&scoped=true"
import script from "./SystemService.vue?vue&type=script&lang=js"
export * from "./SystemService.vue?vue&type=script&lang=js"
import style0 from "./SystemService.vue?vue&type=style&index=0&id=2ed8d237&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed8d237",
  null
  
)

export default component.exports